import { useStore } from 'stores';
import { useTranslation } from 'react-i18next';
import Select from 'components/Select';

export default function LongShortSelect() {
  const { t } = useTranslation();
  const currentLongShort = useStore((state) => state.currentLongShort);
  const setCurrentLongShort = useStore((state) => state.setCurrentLongShort);

  return (
    <Select
      title={t('AllStock.longShort')}
      type="longShort"
      value={currentLongShort}
      onSelectChange={(e) => setCurrentLongShort(e.target.value)}
      className="flex-1"
    />
  );
}
